module.exports = __webpack_public_path__ + "static/img/MockMembers.a4786e0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/MockMembers.png
// module id = 5X6r
// module chunks = 1